import React from 'react'

import { IconArrowDown, IconClose } from '../../../../Ui/Icons'

type Props = {
  mode: 'low' | 'middle' | 'high'
  setMode: (mode: 'low' | 'middle' | 'high') => void
  excursionStart: boolean
  currentStep: number
  name: string | undefined
  closeObject: () => void
}

export function InfoWindowHeader(props: Props) {
  const { mode, setMode, excursionStart, currentStep, name, closeObject } = props

  return (
    <>
      <button className="change__view" onClick={() => setMode(mode === 'low' ? 'middle' : 'low')}>
        <IconArrowDown mode={mode} />
      </button>
      {!excursionStart && (
        <button className="object_close" onClick={closeObject}>
          <IconClose />
        </button>
      )}
      <p className="object__name">
        <span>{`${excursionStart ? `${currentStep + 1}.` : ''}`}</span> {name}
      </p>
    </>
  )
}
